module.exports = __webpack_public_path__ + "static/img/AccountManagement-active.320e8828.svg";